<section>
    <ng-container *ngIf="hasPlaceholder(rendering, 'policyListText')">
        <div class="placeholders" sc-placeholder name="policyListText" [rendering]="rendering"></div>
    </ng-container>
</section>
